import { render, staticRenderFns } from "./SignHeroUserProfile.vue?vue&type=template&id=666b289a&scoped=true"
import script from "./SignHeroUserProfile.vue?vue&type=script&lang=js"
export * from "./SignHeroUserProfile.vue?vue&type=script&lang=js"
import style0 from "./SignHeroUserProfile.vue?vue&type=style&index=0&id=666b289a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666b289a",
  null
  
)

export default component.exports